import { partnershipKey } from './partnershipKey';

export const extractPartnershipsFromGames = (games = []) => games.flatMap((game) => {
  const pairs = [];
  if (Array.isArray(game?.team1?.players) && game.team1.players.length === 2) {
    pairs.push([...game.team1.players]);
  }
  if (Array.isArray(game?.team2?.players) && game.team2.players.length === 2) {
    pairs.push([...game.team2.players]);
  }
  return pairs;
});

// Round allocations are reserved as soon as a round is generated. When an
// unplayed round is regenerated, roll those reservations back first so bench
// and partnership fairness reflect matches that actually remain scheduled.
export const rollbackRoundReservations = ({
  players = [],
  games = [],
  benchPlayers = [],
  benchCount = {},
  usedPartnerships = [],
  partnershipPlayCount = {},
}) => {
  const nextBenchCount = { ...benchCount };
  players.forEach((player) => {
    nextBenchCount[player] = nextBenchCount[player] || 0;
  });
  benchPlayers.forEach((player) => {
    nextBenchCount[player] = Math.max(0, (nextBenchCount[player] || 0) - 1);
  });

  const nextPartnershipPlayCount = { ...partnershipPlayCount };
  extractPartnershipsFromGames(games).forEach((pair) => {
    const key = partnershipKey(pair);
    nextPartnershipPlayCount[key] = Math.max(0, (nextPartnershipPlayCount[key] || 0) - 1);
    if (nextPartnershipPlayCount[key] === 0) delete nextPartnershipPlayCount[key];
  });

  const nextUsedPartnerships = usedPartnerships.filter(
    (pair) => (nextPartnershipPlayCount[partnershipKey(pair)] || 0) > 0
  );

  return {
    benchCount: nextBenchCount,
    usedPartnerships: nextUsedPartnerships,
    partnershipPlayCount: nextPartnershipPlayCount,
  };
};
